// extracted by mini-css-extract-plugin
export default {"search":"search_search__L9A0G","results":"search_results__8UfLV","error":"search_error__S4R2C","result":"search_result__7dsf6"};